module.exports = __webpack_public_path__ + "img/28.78814011.jpg";